/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CreateCourseSectionActivityOptions, CreateCourseSectionActivityResponses } from '../../models/CreateCourseSectionActivity'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Create Course Section Activity
 * {@link /admin/course/activity/create}
 */
export function createCourseSectionActivity<ThrowOnError extends boolean = true>(options: Options<CreateCourseSectionActivityOptions, ThrowOnError>): Promise<UnwrappedResult<CreateCourseSectionActivityResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/course/activity/create', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CreateCourseSectionActivityResponses, ThrowOnError>>
}
